import { PROVINCES, TEER_OPTIONS } from "@/lib/constants";

const PROV_NAME = Object.fromEntries(PROVINCES.map((p) => [p.code, p.name]));

// A light NOC-TEER -> generic search term fallback when no job title is provided.
const TEER_TERM = {
  0: "manager",
  1: "professional",
  2: "technician supervisor",
  3: "skilled worker",
  4: "worker",
  5: "labourer",
};

export function buildJobSearch(profile) {
  const title = (profile.occupationTitle || "").trim();
  const teer = Number(profile.noc_teer);
  const provCode = profile.jobOfferProvince || (profile.provincialConnection || [])[0] || "";
  const provName = PROV_NAME[provCode] || "";
  const term = title || TEER_TERM[teer] || "";
  const totalExp = (Number(profile.foreignExp) || 0) + (Number(profile.canadianExp) || 0);

  const q = encodeURIComponent(term);
  const jobBankLoc = encodeURIComponent(provName ? `${provName}` : "Canada");
  const indeedLoc = encodeURIComponent(provName || "Canada");
  const linkedinLoc = encodeURIComponent(provName ? `${provName}, Canada` : "Canada");

  return {
    term,
    title,
    provName,
    totalExp,
    teerLabel: TEER_OPTIONS.find((o) => o.value === teer)?.label || "",
    links: [
      {
        id: "jobbank",
        name: "Job Bank Canada",
        desc: "Official Government of Canada job board — many postings support LMIA / PNP job offers.",
        url: `https://www.jobbank.gc.ca/jobsearch/jobsearch?searchstring=${q}&locationstring=${jobBankLoc}`,
      },
      {
        id: "indeed",
        name: "Indeed Canada",
        desc: "Canada's largest aggregator of employer job postings.",
        url: `https://ca.indeed.com/jobs?q=${q}&l=${indeedLoc}`,
      },
      {
        id: "linkedin",
        name: "LinkedIn Jobs",
        desc: "Professional roles with employer profiles and easy applications.",
        url: `https://www.linkedin.com/jobs/search/?keywords=${q}&location=${linkedinLoc}`,
      },
    ],
  };
}
